/**
 * WsSubscriptionPlugin — WsSubscriptionCenter 的 Vue 插件封装 [Claude Code]
 *
 * 注册 $wsSubscribe / $wsUpdateIds / $wsUnsubscribe 到 Vue.prototype
 * 通过全局 mixin 在 beforeDestroy 自动清理订阅
 */
import WsSubscriptionCenter from '@/assets/js/wsSubscriptionCenter'
import $store from '@/store/index.js'

let centerInstance = null

export default {
  install (Vue) {
    // 创建单例（延迟获取 $createWebsocket，因为可能在本插件之后注册）[Claude Code]
    const getCenter = () => {
      if (!centerInstance) {
        const createWebsocket = Vue.prototype.$createWebsocket
        centerInstance = new WsSubscriptionCenter($store, createWebsocket)
      }
      return centerInstance
    }

    // 暴露 center 实例（可选，用于高级场景）[Claude Code]
    Object.defineProperty(Vue.prototype, '$wsCenter', {
      get () { return getCenter() }
    })

    /**
     * 注册 WS 轮询订阅 [Claude Code]
     * @param {string} module - 消息类型（sourceStatus / outputStatus / decoderDataV2 / projectStatus）
     * @param {Array} ids - 订阅的 ID 列表
     * @param {Function} callback - 响应回调
     */
    Vue.prototype.$wsSubscribe = function (module, ids, callback) {
      const subscriberId = String(this._uid)
      // 记录该组件订阅了哪些 module，用于 beforeDestroy 自动清理 [Claude Code]
      if (!this._wsSubscriptions) {
        this._wsSubscriptions = new Set()
      }
      this._wsSubscriptions.add(module)
      getCenter().subscribe(module, subscriberId, ids, callback)
    }

    /**
     * 更新订阅的 IDs [Claude Code]
     * @param {string} module - 消息类型
     * @param {Array} newIds - 新的 ID 列表
     */
    Vue.prototype.$wsUpdateIds = function (module, newIds) {
      const subscriberId = String(this._uid)
      getCenter().updateIds(module, subscriberId, newIds)
    }

    /**
     * 手动取消指定 module 的订阅 [Claude Code]
     * @param {string} module - 消息类型
     */
    Vue.prototype.$wsUnsubscribe = function (module) {
      const subscriberId = String(this._uid)
      if (this._wsSubscriptions) {
        this._wsSubscriptions.delete(module)
      }
      getCenter().unsubscribe(module, subscriberId)
    }

    // 全局 mixin：组件销毁时自动清理所有 WS 订阅 [Claude Code]
    Vue.mixin({
      beforeDestroy () {
        if (this._wsSubscriptions && this._wsSubscriptions.size > 0) {
          getCenter().unsubscribeAll(String(this._uid))
          this._wsSubscriptions.clear()
        }
      }
    })
  }
}

// 导出重置函数（测试时使用）[Claude Code]
export function resetCenter () {
  if (centerInstance) {
    centerInstance.destroy()
    centerInstance = null
  }
}
